module.exports = (__parcel__import__("./" + "module.30c25c82.js")).then(() => parcelRequire('2vSYt'));